import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from '@environments/environment';
import { PageNotFoundComponent } from '@shared/components';
import { AuthModule } from './containers/auth/auth.module';
import { AuthGuard } from './core/guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: `${environment.homeRoot}`,
    pathMatch: 'full'
  },
  {
    path: '',
    loadChildren: () => import('@app/containers/dashboard/dashboard.module').then((m) => m.DashboardModule), canActivate: [AuthGuard]
  },
  {
    path: 'auth',
    loadChildren: () => import('@app/containers/auth/auth.module').then((m) => AuthModule)
  },
  {
    path: '**',
    component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
